import React, { useEffect, useState } from "react";
import { ClickAwayListener } from "@material-ui/core";
import calendericon from "../../../../assets/calender_icon.png";
import { Calendar } from "react-date-range";
import moment from "moment";

function DatePicker(props) {
  const { handleDateChange, selectorDate } = props;
  const [display, setDisplay] = useState(false);
  const [newDate, setNewDate] = useState(new Date());

  useEffect(() => {
    setNewDate(selectorDate);
  }, [selectorDate]);

  const handleDatePicker = (value) => {
    setNewDate(value);
    handleDateChange(value);
    setDisplay(false);
  };

  return (
    <div>
      <div className="calendar-container">
        <div>
          <p className="mb-0">{moment(newDate).format("dddd")}, </p>
        </div>
        <div className="calander_div">
          <p className="mb-0" onClick={() => setDisplay(!display)}>
            {moment(newDate).format("DD MMM, yyyy")}
          </p>
          {/* <input autoComplete="off" value={moment().format('DD MMM, yyyy')} onClick={() => setDisplay(!display)} /> */}
          <img
            className="cal_img"
            src={calendericon}
            onClick={() => setDisplay(!display)}
          />
        </div>
      </div>
      {display ? (
        <div className="cal_modal">
          <ClickAwayListener
            onClickAway={() => {
              setDisplay(false);
            }}
          >
            <Calendar
              onChange={(date) => {
                handleDatePicker(date);
              }}
              date={newDate}
              minDate={new Date()}
              maxDate={
                new Date(new Date().getTime() + 365 * 24 * 60 * 60 * 1000)
              }
              color="#F969A4"
            />
          </ClickAwayListener>
        </div>
      ) : (
        ""
      )}
    </div>
  );
}

export default DatePicker;
